var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_238_6966)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_6966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.67 26.4147H15.08C14.62 26.4147 14.25 26.0447 14.25 25.5847C14.25 25.1247 14.62 24.7547 15.08 24.7547H19.66C20.12 24.7547 20.49 25.1247 20.49 25.5847C20.49 26.0447 20.13 26.4147 19.67 26.4147ZM17.58 21.8347H13.83C13.37 21.8347 13 21.4647 13 21.0047C13 20.5447 13.37 20.1747 13.83 20.1747H17.58C18.04 20.1747 18.41 20.5447 18.41 21.0047C18.41 21.4647 18.04 21.8347 17.58 21.8347ZM19.67 17.2547H15.5C15.04 17.2547 14.67 16.8847 14.67 16.4247C14.67 15.9647 15.04 15.5847 15.5 15.5847H19.67C20.13 15.5847 20.5 15.9547 20.5 16.4147C20.5 16.8747 20.13 17.2547 19.67 17.2547Z",
    fill: "#B2B2B2",
    style: {
      fill: "#B2B2B2",
      fill: "color(display-p3 0.6980 0.6980 0.6980)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0599 15.5647C26.1299 15.0347 25.4399 14.7547 25.1299 15.1947L20.8399 21.1947C20.5899 21.5347 20.4699 21.7047 20.4799 21.8447C20.4799 21.9647 20.5399 22.0847 20.6399 22.1547C20.7499 22.2447 20.9599 22.2447 21.3799 22.2447H24.9099C25.2199 22.2447 25.4599 22.5247 25.4199 22.8347L24.9399 26.4347C24.8699 26.9647 25.5599 27.2447 25.8699 26.8047L30.1599 20.8047C30.3999 20.4647 30.5199 20.2947 30.5199 20.1547C30.5199 20.0347 30.4599 19.9147 30.3599 19.8447C30.2499 19.7547 30.0399 19.7547 29.6199 19.7547H26.0899C25.7799 19.7547 25.5399 19.4747 25.5799 19.1647L26.0599 15.5647Z",
    fill: "#B2B2B2",
    style: {
      fill: "#B2B2B2",
      fill: "color(display-p3 0.6980 0.6980 0.6980)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_238_6966",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_238_6966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_238_6966",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_238_6966"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_238_6966"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_238_6966",
    result: "effect3_innerShadow_238_6966"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_6966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.52,
    height: 12.05,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(13 14.9746)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.059d7be93ec14b0a8099bc325d04e35c.svg";
export { ForwardRef as ReactComponent };